import { render, staticRenderFns } from "./LkButton.vue?vue&type=template&id=50510d29&"
import script from "./LkButton.vue?vue&type=script&lang=js&"
export * from "./LkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports